import { View, Text, TouchableOpacity } from "react-native";
import React from "react";
import { normalize } from "@constants/metrics";
import EditIcon from "@assets/svg/EditIcon";

const FloatingTextLabel = ({ label, value, isEditable, onEdit }) => {
  return (
    <View>
      <View
        style={{
          margin: normalize(16),
          borderWidth: 0.5,
          borderColor: "rgba(0, 0, 0, 0.20)",
          justifyContent: "center",
          padding: normalize(14),
          borderRadius: 5,
          position: "relative",
        }}
      >
        <Text
          style={{
            backgroundColor: "white",
            padding: 5,
            borderRadius: 200,
            position: "absolute",
            top: -20,
            left: 10,
            color: "rgba(0, 0, 0, 0.20)",
            fontSize: normalize(14),
            fontFamily: "Mukta",
          }}
        >
          {label}
        </Text>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            // paddingVertical: 12,
          }}
        >
          <Text
            style={{
              color: isEditable ? "#000000" : "rgba(0, 0, 0, 0.36)",
              fontFamily: "NotoSansDevanagari-Bold",
              fontSize: normalize(16),
              textAlign: "center",
              textTransform: "capitalize",
            }}
          >
            {value}
          </Text>
          {isEditable && (
            <TouchableOpacity onPress={onEdit}>
              <EditIcon />
            </TouchableOpacity>
          )}
        </View>
      </View>
    </View>
  );
};

export default FloatingTextLabel;
